import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CloseRoundLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.646 6.354a.5.5 0 1 1 .708-.708L12 11.293l5.646-5.647a.5.5 0 0 1 .708.708L12.707 12l5.647 5.646a.5.5 0 0 1-.708.708L12 12.707l-5.646 5.647a.5.5 0 0 1-.708-.708L11.293 12z", clipRule: "evenodd" }) }) });
}
const CloseRoundLight = forwardRef(_CloseRoundLight);
export { CloseRoundLight };
